/**
 * axios 전역 응답 인터셉터 — 세션 만료 통합 처리
 *
 * 조건: status === 403 AND 응답 본문에 "로그인이 필요합니다" 포함
 * 동작: sessionStorage 정리 → 안내 alert → 로그인 페이지 이동
 *
 * IDOR 방지 403("본인의 정보만...", "권한이 없는 계좌...")은 통과시킴
 */
import axios from 'axios'

let isRedirectingForSessionExpiry = false

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status
    const data = error.response?.data
    const msg = data?.resultMessage || data?.resultMsg || ''

    if (status === 403 && msg.includes('로그인이 필요합니다')) {
      if (!isRedirectingForSessionExpiry) {
        isRedirectingForSessionExpiry = true
        sessionStorage.clear()
        sessionStorage.setItem('sessionExpired', 'true')
        alert('장시간 이용하지 않아 세션이 만료되었습니다.\n다시 로그인해 주세요.')

        window.location.replace('/')
      }

      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
)
